import React, { Component } from 'react';

class WizardStep extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				{this.props.children}
			</div>
		);
	}
}

export default (WizardStep);
